var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 113 29",
    style: {
      enableBackground: "new 0 0 113 29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F7A51D;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "61.7,0 55.5,29 57.5,29 63.7,0  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.5,
    y: 4.5,
    className: "st0",
    width: 3.4,
    height: 19.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 93.7,
    y: 9.6,
    className: "st0",
    width: 3.4,
    height: 14.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.6,
    y: 4.6,
    className: "st0",
    width: 3.6,
    height: 3.4
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.7,19.9l-4-2c-1,1.4-2.6,2.3-4.4,2.3c-3,0-5.5-2.4-5.5-5.5s2.4-5.5,5.5-5.5c1.8,0,3.3,0.8,4.3,2.1l4-2 c-1.7-2.7-4.7-4.5-8.1-4.6c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0c-5.5,0-9.9,4.4-9.9,9.9s4.4,9.9,9.9,9.9 c1.5,0,2.9-0.3,4.2-0.9c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1c0.1,0,0.1-0.1,0.2-0.1c0,0,0,0,0,0C84.4,22.6,85.8,21.4,86.7,19.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113,21l-3.1-1.6c-0.8,1.1-2,1.7-3.4,1.7c-2.3,0-4.2-1.9-4.2-4.2c0-2.3,1.9-4.2,4.2-4.2 c1.4,0,2.6,0.6,3.3,1.6l3.1-1.5c-1.3-2.1-3.6-3.4-6.2-3.5c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0c-4.2,0-7.6,3.4-7.6,7.6 s3.4,7.6,7.6,7.6c1.1,0,2.2-0.3,3.2-0.7c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1-0.1c0,0,0,0,0,0 C111.2,23.1,112.3,22.1,113,21z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,21.7l2.4-2.9c1.3,1.1,2.9,2.2,4.8,2.2c1.5,0,2.5-0.8,2.5-1.9v0c0-1-0.5-1.6-3.3-2.6 c-3.4-1.3-5.5-2.6-5.5-5.9v-0.1c0-3.3,2.6-5.6,6.3-5.6c2.2,0,4.4,0.8,6.2,2.4l-2.2,3C9.8,9.2,8.4,8.4,7,8.4 c-1.4,0-2.2,0.7-2.2,1.7v0c0,1.1,0.7,1.6,3.6,2.9c3.3,1.3,5.2,2.7,5.2,5.7v0.1c0,3.6-2.7,5.8-6.4,5.8C4.7,24.5,2.1,23.6,0,21.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.6,20.4h-8.4l-0.5-2.9l9.2-12.7h3.5v12.2h2.4v3.4h-2.4v4h-3.8V20.4z M23.6,17.1v-6.3l-4.5,6.3H23.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.9,23.6l0.1-0.1c0.1,0,0.1-0.1,0.2-0.1c1.5-0.8,2.8-1.9,3.8-3.4l-3.7-1.9c-1.1,1.4-2.8,2.2-4.6,2.2 c-3.2,0-5.8-2.6-5.8-5.8c0-3.2,2.6-5.8,5.8-5.8c1.7,0,3.4,0.8,4.5,2.1l3.7-1.9c-1.8-2.6-4.7-4.3-7.9-4.3c-0.1,0-0.2,0-0.2,0 c-5.4,0-9.9,4.4-9.9,9.8s4.4,9.8,9.8,9.8C42.2,24.5,43.6,24.2,44.9,23.6"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.6082a262a24bf57e681c04dd10b0e291.svg";
export { ForwardRef as ReactComponent };